module.exports = __webpack_public_path__ + "static/media/galerija_2019 (30).93b8087d.jpg";